<template>
  <div class="setting">
    <div class="description">
      見積情報&nbsp;確認&nbsp;&nbsp;<span class="square"></span>セルに設定値を入力
    </div>
    <div class="title">見積情報</div>
    <div class="list">
      <table border v-if="estimate">
        <tr>
          <td class="item">作成日</td>
          <td class="value">
            <input type="date" :value="estimate.createdAt"
                   v-html="estimate.createdAt != null ? estimate.createdAt.replace(/\//g,'-') : ''"
                   @change="$emit('changeEstimateValue', 'createdAt', $event)"/>
          </td>
        </tr>
        <tr v-if="isOrder">
          <td class="item">スケッチID</td>
          <td class="value">
            <input type="text" class="sketch_id" :value="estimate.sketchId"
                   @change="$emit('changeEstimateValue', 'sketchId', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">プランID</td>
          <td class="value">
            <input type="text" class="plan_id" :value="estimate.planId"
                   @change="$emit('changeEstimateValue', 'planId', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">見積書記載企業名</td>
          <td v-if="isOrder" class="value">
            <select v-model="corpName">
              <option v-for="(type,index) in estimate.estimateCorpList" :key="index" :value="type.businessId">{{type.businessName}}</option>
            </select>
          </td>
          <td v-else>
            <input type="text" :value="estimate.companyName"
                   @change="$emit('changeEstimateValue', 'companyName', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">担当者</td>
          <td class="value">
            <input type="text" :value="estimate.parsonName"
                   @change="$emit('changeEstimateValue', 'parsonName', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">得意先名</td>
          <td class="value">
            <input type="text" :value="estimate.clientName"
                   @change="$emit('changeEstimateValue', 'clientName', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">得意先部署名</td>
          <td class="value">
            <input type="text" :value="estimate.clientDepartment"
                   @change="$emit('changeEstimateValue', 'clientDepartment', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">得意先担当者名</td>
          <td class="value">
            <input type="text" :value="estimate.clientParsonName"
                   @change="$emit('changeEstimateValue', 'clientParsonName', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">納品先名</td>
          <td class="value">
            <input type="text" :value="estimate.deliveryName"
                   @change="$emit('changeEstimateValue', 'deliveryName', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">物件名</td>
          <td class="value">
            <input type="text" :value="estimate.propertyName"
                   @change="$emit('changeEstimateValue', 'propertyName', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">納入場所_住所1</td>
          <td class="value">
            <input type="text" :value="estimate.deliveryAddr1"
                   @change="$emit('changeEstimateValue', 'deliveryAddr1', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">納入場所_住所2</td>
          <td class="value">
            <input type="text" :value="estimate.deliveryAddr2"
                   @change="$emit('changeEstimateValue', 'deliveryAddr2', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">希望納品日</td>
          <td class="value">
            <input type="date" :value="estimate.deliveryDate"
                   v-html="estimate.deliveryDate != null ? estimate.deliveryDate.replace(/\//g,'-') : ''"
                   @change="$emit('changeEstimateValue', 'deliveryDate', $event)"/>
          </td>
        </tr>
        <tr>
          <td class="item">支払い条件</td>
          <td class="value">
            <input type="text" :value="estimate.paymentConditions"
                   @change="$emit('changeEstimateValue', 'paymentConditions', $event)"/>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import * as AppUtil from '../../utils/App'
export default {
  name: 'SettingValue',
  props: {
    estimate: null
  },
  data () {
    return {
      corpName: ''
    }
  },
  computed: {
    isOrder: function () {
      let user = AppUtil.getUserInfo()
      if (user.corpId === 170) {
        return true
      }
      return false
    }
  },
  created () {
    this.corpName = this.estimate.estimateCorpName
  }
}
</script>

<style lang="scss" scoped>
.setting {
  .description {
    margin: 3px 0 6px 0;
    font-size: 13px;
    .square {
      width: 28px;
      height: 20px;
      background: #FDF2CF;
      display: inline-block;
      vertical-align: text-bottom;
      border: 2px solid #305496;
      margin-right: 5px;
      margin-left: 20px;
    }
  }
  .title {
    background: #D6DCE4;
    padding: 10px;
  }
  .list {
    padding: 20px;
    background: #F2F2F2;
    table {
      td {
        padding: 0;
        border-bottom: none;
        background: none;
      }
      .item {
        width: 100px;
      }
      .value {
        width: 200px;
      }
      input {
        background-color: #FDF2CF;
        width: 90%;
        border-radius: unset;
        border: 0;
        box-shadow: 0 0 1px 0 #000000;
        &.plan_id {
          background-color: #ffffff;
        }
        &.sketch_id {
          background-color: #ffffff;
        }
      }
      input:focus {
        outline: 2px solid #089569;
      }
      select {
        width: 96%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/SettingValue.vue